<script setup lang="ts">
const { t } = useI18n()

const showModal = ref(false)
const msg = ref<string>('')
const btnText = ref<string>()
const callback = ref<() => void>()
useLockAppScrollWhenVisible(showModal)
const openExternalBrowserRef = ref()
const close = () => {
  showModal.value = false
}

const open = (_msg: string, _text?: string, _callback?: () => void) => {
  msg.value = _msg
  showModal.value = true
  btnText.value = _text
  callback.value = _callback
}

defineExpose({
  close,
  open,
})
</script>

<template>
  <n-modal
    v-model:show="showModal"
    :on-after-leave="close"
    :mask-closable="false"
    transform-origin="center"
  >
    <div class="relative">
      <img
        v-if="openExternalBrowserRef.value?.check()"
        src="@/assets/image/browser-img.webp"
        class="w-95vw fixed top-3 left-50% -translate-x-1/2"
      />
      <div class="modal-content pt-4 px-4 pb-1.5 sm:w-90 w-85.75">
        <div class="text-4 break-words">
          {{ msg }}
        </div>
        <div flex items-center justify-end mt-3>
          <DfansButton
            :text="t('Global.CLOSE')"
            type="ghost"
            :class="`h-9 w-max !rounded-full ${btnText ? 'mr-2' : '-mr-2.5'}`"
            @click="close"
          />
          <DfansButton
            v-if="btnText"
            :text="btnText.toUpperCase()"
            type="ghost"
            class="h-9 w-max !rounded-full -mr-2.5"
            @click="callback"
          />
        </div>
      </div>
    </div>
  </n-modal>
  <OpenExternalBrowser ref="openExternalBrowserRef" is-init />
</template>
